<mat-card class="cardWithShadow">
  <mat-card-header style="align-items: baseline; padding: 24px 24px 0 24px;">
    <div style="display: flex; align-items: baseline; gap: 16px; flex-wrap: wrap;">
      
      <mat-form-field appearance="outline" class="hide-hint" style="min-width: 280px;">
        <mat-label>Buscar Solicitud</mat-label>
        <input matInput (keyup)="applyFilter()" placeholder="Buscar por cliente, local, ticket..." #input>
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="hide-hint" style="min-width: 220px;" *ngIf="isGruman">
        <mat-label>Cliente</mat-label>
        <mat-select [(value)]="selectedClientId" (selectionChange)="onClientFilterChange()">
          <mat-option [value]="null">Todos los clientes</mat-option>
          <mat-option *ngFor="let cliente of clientes" [value]="cliente.id">
            {{ cliente.nombre }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="hide-hint" style="min-width: 120px;">
        <mat-label>Mes</mat-label>
        <mat-select [(value)]="selectedMes" (selectionChange)="onDateFilterChange()">
          <mat-option value="">Todos</mat-option>
          @for (mes of meses; track mes) {
            <mat-option [value]="mes">{{ mes }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="hide-hint" style="min-width: 100px;">
        <mat-label>Año</mat-label>
        <mat-select [(value)]="selectedAnio" (selectionChange)="onDateFilterChange()">
          <mat-option value="">Todos</mat-option>
          @for (anio of anios; track anio) {
            <mat-option [value]="anio.toString()">{{ anio }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="hide-hint" style="min-width: 220px;">
        <mat-label>Tipo de Servicio</mat-label>
        
        <mat-select [(value)]="selectedServiceType" (selectionChange)="onServiceTypeChange()">
          
          <mat-select-trigger>
            @if (selectedServiceType) {
              <app-service-badge [label]="selectedServiceType"></app-service-badge>
            } @else {
              Todos los servicios
            }
          </mat-select-trigger>

          <mat-option value="">Todos los servicios</mat-option>
          
          @for (tipo of tiposServicio; track tipo.id) {
            <mat-option [value]="tipo.nombre"> 
              <app-service-badge [label]="tipo.nombre"></app-service-badge>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <button mat-icon-button type="button" color="primary" (click)="resetFilters()" matTooltip="Limpiar filtros" style="top: 6px;">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>

    <div style="flex: 1 1 auto;"></div>
    
    <div style="display: flex; align-items: center; gap: 8px;">
      <button mat-stroked-button color="primary" (click)="exportarExcel()">
        <mat-icon>file_download</mat-icon> Exportar
      </button>
    </div>
  </mat-card-header>

  <mat-card-content class="p-24">
    <div *ngIf="loading" class="loading-container" style="display: flex; justify-content: center; align-items: center; padding: 40px;">
      <mat-spinner diameter="40"></mat-spinner>
      <p style="margin-left: 16px;">Cargando solicitudes...</p>
    </div>

    <div class="table-responsive m-t-16" [hidden]="loading">
      <table mat-table [dataSource]="dataSource" matSort class="w-100">
        
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>N° Ticket</th>
          <td mat-cell *matCellDef="let element">{{element.id}}</td>
        </ng-container>

        <ng-container matColumnDef="fechaIngreso">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha Ingreso</th>
          <td mat-cell *matCellDef="let element">{{ formatDateUTC(element.fechaIngreso) }}</td>
        </ng-container>

        <ng-container matColumnDef="cliente">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="client.nombre">Cliente</th>
          <td mat-cell *matCellDef="let element">{{element.client?.nombre || 'N/A'}}</td>
        </ng-container>

        <ng-container matColumnDef="local">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="local.nombre_local">Local</th>
          <td mat-cell *matCellDef="let element">{{element.local?.nombre_local || 'N/A'}}</td>
        </ng-container>

        <ng-container matColumnDef="direccion">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="local.direccion">Dirección</th>
          <td mat-cell *matCellDef="let element" [matTooltip]="element.local?.direccion || element.direccion">
            {{(element.local?.direccion || element.direccion)?.length > 30 ? ((element.local?.direccion || element.direccion) | slice:0:30) + '...' : (element.local?.direccion || element.direccion || 'N/A')}}
          </td>
        </ng-container>

        <ng-container matColumnDef="comuna">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="comuna_nombre">Comuna</th>
          <td mat-cell *matCellDef="let element">{{element.local?.comuna?.comuna_nombre || element.comuna_nombre || 'N/A'}}</td>
        </ng-container>

        <ng-container matColumnDef="zona">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="f-w-600 f-s-14"> Zona </th>
          <td mat-cell *matCellDef="let element" class="f-s-14"> 
            <span class="p-x-8 p-y-4 bg-light-primary rounded f-w-600 text-primary f-s-12">
              {{ element.zona }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="especialidad">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="f-w-600 f-s-14"> Especialidad </th>
          <td mat-cell *matCellDef="let element" class="f-s-14"> {{ element.especialidad_nombre }} </td>
        </ng-container>

        <ng-container matColumnDef="ticketGruman">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>IDTicket Cliente</th>
          <td mat-cell *matCellDef="let element">{{element.ticketGruman || 'Sin ticket'}}</td>
        </ng-container>

        <ng-container matColumnDef="observaciones">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Observaciones</th>
          <td mat-cell *matCellDef="let row" [matTooltip]="row.observaciones">{{ row.observaciones?.length > 50 ? (row.observaciones | slice:0:50) + '...' : row.observaciones }}</td>
        </ng-container>

        <ng-container matColumnDef="generado_por">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="generada_por.name">Generado por</th>
          <td mat-cell *matCellDef="let row">{{row.generada_por ? (row.generada_por.name + ' ' + row.generada_por.lastName) : 'N/A'}}</td>
        </ng-container>

        <ng-container matColumnDef="tipoServicio">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="tipoServicio.nombre">
            Tipo de Servicio
          </th>
          <td mat-cell *matCellDef="let row">
            <app-service-badge [label]="row?.tipoServicio?.nombre"></app-service-badge>
          </td>
        </ng-container>

        <ng-container matColumnDef="tipo_solicitud">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="tipo_solicitud.nombre">Tipo Solicitud</th>
          <td mat-cell *matCellDef="let row">{{ row?.tipo_solicitud?.nombre || '' }}</td>
        </ng-container>

        <ng-container matColumnDef="tiempo_restante">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="tiempo_restante">Tiempo restante</th>
          <td mat-cell *matCellDef="let element">
            <small [ngStyle]="{'color': getTiempoRestante(element).includes('Vencido') ? '#dc3545' : '#28a745'}">
              {{ getTiempoRestante(element) }}
            </small>
          </td>
        </ng-container>

        <ng-container matColumnDef="estado">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let element">
            <span class="modern-chip-subtle" [ngClass]="{
              'bg-warning': element.status === 'pendiente',
              'bg-success-light': element.status === 'aprobada',
              'bg-info-light': element.status === 'programada'
            }">
              {{ element.status | titlecase }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="imagenes">
          <th mat-header-cell *matHeaderCellDef>Imágenes</th>
          <td mat-cell *matCellDef="let element">{{ element.imagenes?.length || 0 }}</td>
        </ng-container>

        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef>Acciones</th>
          <td mat-cell *matCellDef="let element" class="p-l-0">
            <button *ngIf="canViewDetail(element)" mat-icon-button (click)="verSolicitud(element)" color="primary" matTooltip="Ver/Gestionar Solicitud">
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="11">
            <div class="no-data-message">
              <mat-icon>search_off</mat-icon>
              <p>No se encontraron coincidencias para "{{input.value}}"</p>
              <p class="text-muted">Intenta con otros términos de búsqueda.</p>
            </div>
          </td>
        </tr>
      </table>
    </div>

    <div class="paginator-container" [hidden]="loading">
      <mat-paginator #paginator 
        [length]="totalItems" 
        [pageSize]="10" 
        [pageSizeOptions]="[5, 10, 25, 50]" 
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>